import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

/**
 * Submits feedback from a logged-in user.
 * @param {object} feedbackData - The feedback data, containing feedback_text and rating.
 * @param {string} token - The user's JWT token.
 * @returns {Promise<object>} The response from the server.
 */
export const submitFeedback = async (feedbackData, token) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/api/feedback`,
            feedbackData,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return response.data;
    } catch (error) {
        throw error.response?.data || { message: 'An unknown error occurred.' };
    }
};
